import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import {
  Galerie2it4iComponent,
  Galerie2iv2itComponent,
  Galerie4itivComponent,
  GalerieIt2iviComponent,
} from '@components/galerie';
import { Galerie } from '@components/galerie/models';
import { Image } from '@shared/components/image/models';
import { PopinImageComponent } from '@shared/components/popin-image';
import { DialogService } from '@shared/services/dialog';

@Component({
  selector: 'app-galerie',
  imports: [GalerieIt2iviComponent, Galerie4itivComponent, Galerie2iv2itComponent, Galerie2it4iComponent],
  templateUrl: './galerie.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalerieComponent extends AbstractDynamicComponent<Galerie> {
  private readonly dialogService = inject(DialogService);

  openVisualFullScreenModal(image: Image): void {
    this.dialogService.openDialog(PopinImageComponent, 'FULL_SCREEN', {
      data: {
        image,
      },
    });
  }
}
